import React from 'react'
import ItemSummary from './itemsummary';
import { containerIprops } from './itemsummaryinterface';


const ItemSummaryContainer = (props: containerIprops) => {

    return (
        <ItemSummary partData={props?.partData} />
    )
}

export default ItemSummaryContainer;